<video id={{id}} disablePictureInPicture *ngIf="videoUrl"  controlsList="nodownload" class="video-js" poster="{{posterUrl}}" controls
    preload="auto" data-setup='{}' #videoPlayer>
    <source src="{{videoUrl}}" type="video/mp4" />
    <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank" rel="noopener">
            supports HTML5 video
        </a>
    </p>
</video>